<template>
	<div class="body column">
		<Toolbar />
		<div class="holiday_notice">Your custom order will take a couple of weeks as it's crafted just for you.</div>
		
				<!-- <div class="holiday_notice">** The store is closed from Friday the 19th Dec to Friday 2nd Jan - <b>Any orders placed from Monday 15th Dec will be shipped in January.</b> **</div> -->

		<div class="main">
			<div class="page">
				<nuxt />
			</div>
		</div>
		<Housekeeping />
	</div>
</template>

<script>
	import '~/components/filters';
	import Toolbar from '~/components/Toolbar.vue';
	import Housekeeping from '~/components/Housekeeping.vue';

	export default {
		components: {
			Toolbar,
			Housekeeping,
		},
		head() {
			return {
				link: [
					{
						rel: "preconnect",
						href: this.$store.state.global.api_path,
					},
				],
			};
		},
		methods: {
			load_storage(item) {
				const data = localStorage.getItem(item);
				if (data) {
					const json = JSON.parse(data);
					this.$store.commit(`${item}/set`, json);
				}
			}
		},
		errorCaptured(err, vm, info) {
			if (typeof err.message != 'string') {
				return false;
			}
			var data = {};
			if (typeof err.stack != 'undefined') {
				data.stacktrace = err.stack;
			}
			data.msg = err.message;
			data.script = err.fileName;
			data.line = err.lineNumber;
			data.col = err.columnNumber;
			if (document.activeElement && document.activeElement.id) {
				data.active = document.activeElement.id;
			}
			// hack while Chrome sort themselves out!
			if (err.message != 'ResizeObserver loop limit exceeded') {
				var xho = new XMLHttpRequest();
				xho.open('post', `https://${this.$store.state.global.is_dev ? 'dev-' : ''}support.asagroup.ie/public/api/js_error.php`, true);
				xho.setRequestHeader("Content-Type", "text/plain");
				xho.send(JSON.stringify(data));
			}
		},
		mounted() {
			switch (this.$i18n.locale) {
				case 'default': {
					window.location = '/';
					return;
				}
				case 'us': {
					this.$store.commit('session/set', {
						currency_symbol: "&dollar;",
						currency_code: "USD",
					});
					break;
				}
				case 'eu': {
					this.$store.commit('session/set', {
						currency_symbol: "&euro;",
						currency_code: "EUR",
					});
					break;
				}
			}
			this.load_storage('session');
			this.load_storage('subcategories');
			this.load_storage('cart');

			var force_login = true;

			// otherwise force a log in if there isn't a payment key set
			if (this.$route.query.payment_key) force_login = false;
			if (this.$route.query.carriage_key) force_login = false;

			if (this.$store.state.session.signed_in == false && force_login) {
				this.$router.push('/auth');
			}

		}
	};
</script>